import styles from "./index.css?inline";

export const PM_REACT_MESSAGING_STYLES = styles;

